// Lib imports
import React from "react";

// Util imports
import urlGenerator from "src/utils/urlGenerator";

// Component imports
import ActiveLink from "src/components/layouts/ActiveLink";
import Skeleton from "src/components/elements/Skeleton";

// Style imports
import styles from "src/styles/components/pages/category/categoriesSidebarListing.module.scss";

const CategoriesSidebarListing = React.memo(({ categories }) => {
  return (
    <div className={styles.sidebar_list}>
      <div className={styles.list_title}>
        <p>Help Topics</p>
        <div className={styles.mid_divider}></div>
      </div>
      <div className={styles.topic_list}>
        <ul>
          {categories?.docs?.length > 0
            ? categories.docs.map(({ name, _id, slug }) => (
                <li key={_id}>
                  <ActiveLink
                    activeClassName={styles.active}
                    href={urlGenerator.categoryLink(slug)}
                    scroll={false}
                    withoutQuery
                  >
                    <span className={`${styles.btn}`}>
                      {name?.length > 50 ? `${name.slice(0, 50).trim()}...` : name}
                    </span>
                  </ActiveLink>
                </li>
              ))
            : [...Array(6)].map((_, index) => (
                <li key={index}>
                  <span className={`${styles.btn}`}>
                    <Skeleton />
                  </span>
                </li>
              ))}
        </ul>
      </div>
    </div>
  );
});

CategoriesSidebarListing.displayName = "CategoriesSidebarListing";

export default CategoriesSidebarListing;
